import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const ArchiveIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.25 9C7.83582 9 7.5 9.33579 7.5 9.75C7.5 10.1642 7.83582 10.5 8.25 10.5H11.75C12.1642 10.5 12.5 10.1642 12.5 9.75C12.5 9.33579 12.1642 9 11.75 9H8.25Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 2.5H16.25C17.2166 2.5 18 3.2835 18 4.25V5.75C18 6.44811 17.5913 7.05074 17 7.3316V15.25C17 16.4926 15.9927 17.5 14.75 17.5H5.25C4.00732 17.5 3 16.4926 3 15.25V7.3316C2.40869 7.05074 2 6.44811 2 5.75V4.25C2 3.2835 2.78345 2.5 3.75 2.5ZM4.5 7.5H15.5V15.25C15.5 15.6642 15.1642 16 14.75 16H5.25C4.83582 16 4.5 15.6642 4.5 15.25V7.5ZM3.75 4C3.61194 4 3.5 4.11193 3.5 4.25V5.75C3.5 5.88807 3.61194 6 3.75 6H16.25C16.3881 6 16.5 5.88807 16.5 5.75V4.25C16.5 4.11193 16.3881 4 16.25 4H3.75Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
